<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="csv" class="mr-2">Selecione o CSV:</label>
          <input type="file" ref="file" accept=".csv" />
          <button class="btn btn-primary" @click.prevent="showDados">
            Ver contatos
          </button>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="mr-2">Para quem:</label>
          <input
            type="text"
            placeholder="Ex: Pintor"
            v-model="dados.type"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="nome"
            >Mensagem (Para usar o '$nome', para usar a '$profissao')</label
          >
          <textarea
            rows="3"
            class="form-control"
            placeholder="Ex: acesse nosso site e veja as vantagens"
            v-model="dados.message"
          >
          </textarea>
        </div>
      </div>
    </div>

    <button
      class="btn btn-success"
      :disabled="valid == 0"
      @click.prevent="submit"
    >
      Enviar mensagem
    </button>

    <b-modal size="xl" id="modalMensage" ref="modalMensage" hide-footer>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Qtd</th>
                <th scope="col">Nome</th>
                <th scope="col">Telefone</th>
                <th scope="col">Profissão</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, i) in dados.csvData" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ data.nome }}</td>
                <td>{{ data.telefone }}</td>
                <td>{{ data.profissao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <b-button
        class="btn btn-danger mt-3"
        block
        @click="$bvModal.hide('modalMensage')"
        >Fechar dados</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import papa from 'papaparse';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'WhatsApp',
  mixins: [makeToast],

  data() {
    return {
      valid: 0,
      dados: {
        type: '',
        message: '',
        csvData: null,
      },
    };
  },

  methods: {
    showDados() {
      const csvFile = this.$refs.file.files[0];
      if (csvFile === undefined) {
        this.dados.csvData = null;
        this.makeToast(
          'Oopss',
          'CSV sem contatos para disparo de mensagens!',
          'danger'
        );
        return;
      }

      this.valid = 1;
      const that = this;

      this.$refs.modalMensage.show();

      papa.parse(csvFile, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        preview: 500,
        complete(result) {
          that.dados.csvData = result.data;
        },
      });
    },
    submit() {
      if (this.dados.csvData === null) {
        this.makeToast(
          'Oopss',
          'CSV sem contatos para disparo de mensagens!',
          'danger'
        );
        return;
      }
      if (this.dados.message === '') {
        this.makeToast(
          'Oopss',
          'Escreva uma mensagem para continuar!',
          'danger'
        );
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('partner/submitWhatsAppMessage', this.dados)
        .then(() => {
          this.makeToast('Sucesso', 'Mensagem enviada com sucesso!', 'success');
        })
        .catch(() =>
          this.makeToast('Oopss', 'Erro ao enviar mensagem!', 'danger')
        )
        .finally(() => this.$store.dispatch('endLoader'));
    },
  },
};
</script>

<style></style>
